import React from 'react';
import {InputGroup} from '@blueprintjs/core';

import {StyledFormGroup, RoundedInputWrap} from './shared';


const TextField = ({label, value, disabled, error, nullable, optional, icon, onChange}) => {
    const intent = error ? 'danger' : 'none';
    return (
        <StyledFormGroup label={label} helperText={error?.message} intent={intent}>
            <RoundedInputWrap>
                <InputGroup
                    fill={true}
                    value={value ?? ''}
                    disabled={disabled}
                    intent={intent}
                    leftIcon={icon}
                    placeholder={optional ? '(optional)' : undefined}
                    onChange={(e) => {
                        const v = e.target.value;
                        onChange(nullable && v === '' ? null : v);
                    }}
                />
            </RoundedInputWrap>
        </StyledFormGroup>
    );
};

export {TextField};
